// extracted by mini-css-extract-plugin
export default {"main":"ItemsToBringPage-module__main--HkxKW","ctaContainer":"ItemsToBringPage-module__ctaContainer--b0SfI","heading":"ItemsToBringPage-module__heading--PxzfR"};